<template>
    <section class="uses-tailwind">
        <h2 class="text-center text-lg font-bold">
            {{ trans('production_progress.total_progression') }}
        </h2>
        <production-progress-bar
            :progress="progress"
            class="mb-3 mt-2"
        />
    </section>
</template>

<script>
import ProductionProgressBar from './ProductionProgressBar.vue';

export default {
    props: {
        progress: {
            type: Number,
            required: true,
        },
    },
    components: {
        ProductionProgressBar,
    },
};
</script>
